if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );
        this.querySelector(".loading-overlay").classList.remove("hidden");

        var this2 = this;

        if ($("#custom--product-addon").is(":checked")) {
          var ID = $("#custom--product-addon").attr("varid");
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: {
              quantity: 1,
              id: ID,
            },
            dataType: "json",
            success: function (data) {
              addcart();
            },
          });
        }else{
          addcart();
        }

        function addcart() {
          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];

          const formData = new FormData(this2.form);
          if (this2.cart) {
            formData.append(
              "sections",
              this2.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
            this2.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.description,
                  message: response.message,
                });
                this2.handleErrorMessage(response.description);

                const soldOutMessage =
                  this2.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this2.submitButton.setAttribute("aria-disabled", true);
                this2.submitButton
                  .querySelector("span")
                  .classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this2.error = true;
                return;
              } else if (!this2.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this2.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                });
              this2.error = false;
              const quickAddModal = this2.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this2.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this2.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              console.log("ok");
              this2.submitButton.classList.remove("loading");
              if (this2.cart && this2.cart.classList.contains("is-empty"))
                this2.cart.classList.remove("is-empty");
              if (!this2.error)
                this2.submitButton.removeAttribute("aria-disabled");
              this2
                .querySelector(".loading-overlay__spinner")
                .classList.add("hidden");
              this2.querySelector(".loading-overlay").classList.add("hidden");
            });
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
